import { IHowToManageTeamAdvice } from '@components/services/dedicated-teams/dedicated-teams.state';
import template from '@components/services/services.module.scss';
import style from './how-to-manage-team.module.scss';
import DedicatedDevelopmentTeamsSection
    from '@components/services/dedicated-teams/sections/dedicated-development-teams-section/dedicated-development-teams-section';

interface IHowToManageTeamProps {
    title: string;
    description: string[];
    imageSrc: string;
    advices: IHowToManageTeamAdvice[];
}

const HowToManageTeamSection = ({ title, description, imageSrc, advices }: IHowToManageTeamProps) => {
    return (
        <section className={`${template.section} ${template.section_gray} ${template.section} ${style.manage_section} ${style.section}`}>
            <div className={`${template.container} ${style.block} ${template.flex} ${template.flex_justify_content_space_between}`}>
                <DedicatedDevelopmentTeamsSection
                    imageSrc={imageSrc}
                    title={title}
                    text={description}
                />
            </div>
            <div className={`${template.container} ${template.container_large} ${style.manage_advices}`}>
                {
                    advices.map((advice: IHowToManageTeamAdvice, index: number ) => {
                        return (
                            <div key={index} className={`${style.manage_advice}`}>
                                <div className={`${template.title_small} ${template.text_color_main} ${style.manage_advice_title}`}>
                                    {advice.title}
                                </div>
                                <div className={`${template.text_small} ${template.text_color_main} ${style.manage_advice_description} ${template.fw400}`}>
                                    {advice.description}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </section>
    );
}

export default HowToManageTeamSection;
